import { CustomFieldDataType } from 'shared'
import { CIMSSingleColumn } from '../../../../CIMSTable/CIMSColumn/types'

export function align<T>(dataTypeId: string): CIMSSingleColumn<T>['align'] {
  if (dataTypeId === CustomFieldDataType.Boolean.id) return 'center'
  if (dataTypeId === CustomFieldDataType.Number.id) return 'right'
  if (dataTypeId === CustomFieldDataType.Date.id) return 'center'
  return 'left'
}
